import { useState, useEffect, useCallback, useRef } from "react";
import { CheckNull, dateCheck, getStorageData } from '../../utils/Validate';
import { useLocation, useNavigate } from "react-router-dom";
import validation, { conValidation, validationContact } from "./validation";
import { CreateEntry, UpdateEntry, GetList } from '../../providers/dataProvider';
import { SuccessMessages, ErrorMessages } from "../../constants/MessageConstants";

const defaultCustomer = {
  projectCode: "N",
  customerName: "",
  countryId: null,
  website: "",
  fax: "",
  phone: "",
  address: "",
  email: "",
  type: "2",
  statusId: 1,
  distributorId: "",
  additionalInfo: "",
  assignedEngineerId: "",
  CustomerContact: [],
  CustomerDocument: []
}

const useForm = (designationdata, customerdata, projectdata, distributordata, countrydata, userprofiledata, customertypedata) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    projectCode: "N",
    projectName: "",
    projectSegmentId: 0,
    projectStatusId: 0,
    mainContractorId: "",
    mepContractorId: "",
    designConultantId: "",
    supervisionConsultantId: "",
    clientId: "",
    distributorId: "",
    countryId: 0,
    startDate: new Date(),
    endDate: new Date(),
    additionalInfo: "",
    createdBy: localStorage.getItem("authidentity"),
    projectContacts: [],
    subContractors: []
  });
  const [errorShow, setErrorShow] = useState({
    show: false,
    errorMessage: ""
  });
  const [editProject, setEditProject] = useState({});
  const [contractorShow, setContractorShow] = useState(false);
  const [prjcreateMsg, setPrjcreateMsg] = useState(null);
  const [MEPlistData, setListData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [addMEP, setaddMEP] = useState(null)
  const [show, setShow] = useState(false);
  const [addtoListMEP, setaddtoListMEP] = useState([])
  const [contactShow, setContactShow] = useState(false);
  const [disabledCust, setDisabledCust] = useState(false);
  const [contractorValue, setContractorValue] = useState({});
  const [contacttemp, setContactTemp] = useState({
    id: 0,
    name: "",
    email: "",
    phone: "",
    designationId: 0,
    departmentId: 0,
    designation: ""
  })
  const [contact, setContact] = useState([])
  const [contactError, setContactError] = useState({})
  const [contactSubmit, setContactSubmit] = useState(false)
  const [condepartment, setConDepartment] = useState(null);
  const [condesignation, setConDesignation] = useState(null);

  const [prjSegment, setprjSegment] = useState(null);
  const [prjStatus, setprjStatus] = useState(null);

  const [prjmepCust, setprjmepCust] = useState(null);
  const [prjmainCust, setprjMainCust] = useState(null);

  const [prjDesignCust, setprjDesignCust] = useState(null);
  const [prjSuperCust, setprjSuperCust] = useState(null);

  const [prjClientCust, setprjClientCust] = useState(null);
  const [prjDistributorCust, setprjDistCust] = useState(null);

  const [prjCountry, setprjCountry] = useState(null);

  const [prjStartDate, setprjStartDate] = useState(new Date());
  const [prjEndDate, setprjEndDate] = useState(new Date());

  const [formErrors, setFormError] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const [disabledSubmit, setDisabledSubmit] = useState(false);

  useEffect(() => {
    if (location?.state) {
      const item = location?.state;
      if (item?.id) {
        if (item?.canEdit !== true) navigate("/dashboard")
        setEditProject(item?.row);
      }
      else {
        if (item?.canAdd !== true) navigate("/dashboard")
      }
    }
    else {
      navigate("/dashboard")
    }
  }, [])

  useEffect(() => {
    if (editProject?.id) {
      setFormValues({
        id: editProject?.id,
        projectId: editProject?.id,
        projectCode: editProject?.projectCode,
        projectName: editProject?.projectName,
        projectSegmentId: editProject?.projectSegmentId,
        projectStatusId: editProject?.projectStatusId,
        mainContractorId: editProject?.mainContractorId,
        mepContractorId: editProject?.mepContractorId,
        designConultantId: editProject?.designConultantId,
        supervisionConsultantId: editProject?.supervisionConsultantId,
        clientId: editProject?.clientId,
        distributorId: editProject?.distributorId,
        countryId: editProject?.countryId,
        startDate: dateCheck(editProject?.startDate),
        endDate: dateCheck(editProject?.endDate),
        additionalInfo: editProject?.additionalInfo,
        modifiedBy: localStorage.getItem("authidentity"),
        createdBy: editProject?.createdBy,
        createdAt: editProject?.createdAt,
        modifiedAt: new Date(),
        projectContacts: editProject?.projectContacts ? editProject?.projectContacts : [],
        subContractors: editProject?.subContractors ? editProject?.subContractors : [],
      })

      setprjStartDate(dateCheck(editProject?.startDate))
      setprjEndDate(dateCheck(editProject?.endDate))

      setContact(editProject?.projectContacts?.map((element, index) => {
        var designationValue = designationdata.filter(item => item.id === element?.designationId)
        if (designationValue) element.designation = designationValue[0]?.designationName
        return element;
      }
      ));

      let addcontracttemp = [];
      editProject?.subContractors?.map((element, index) => {
        addcontracttemp.push({
          value: element.customerID,
          label: element.subContractorName
        })
      }
      )

      setaddtoListMEP(addcontracttemp);

    }
  }, [editProject, designationdata])

  const ContractorOpen = () => {
    setContractorShow(true);
  }

  const HandleFormChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });

    const errors = validation({
      ...formValues,
      [name]: value
    });

    setFormError({
      ...formErrors,
      [name]: errors[name]
    });
  };

  const HandleDropDownChange = (selectedOption, params) => {
    if (params === "distributorId") {
      setFormValues({
        ...formValues,
        countryId: selectedOption?.countryId,
        clientId: "",
        mepContractorId: "",
        mainContractorId: "",
        designConultantId: "",
        supervisionConsultantId: "",
        [params]: selectedOption?.value,
      });
      setaddtoListMEP([])
    }
    else {
      setFormValues({
        ...formValues,
        [params]: selectedOption?.value || "",
      });
    }

    const errors = validation({
      ...formValues,
      [params]: selectedOption?.value
    });

    setFormError({
      ...formErrors,
      [params]: errors[params]
    });
  };

  useEffect(() => {
    if (customerdata) {
      const list = formatCustomerList(customerdata);
      setCustomerData(list);
    }
  }, [customerdata]);

  const formatCustomerList = (list) => {
    var te = list?.map((data, index) => ({
      ...data,
      label: data?.customerName,
      value: data?.id,
      type: data?.type,
    }));
    return te;
  };

  const HandleMEPChange = (selectedOption) => {
    setaddMEP(selectedOption)
  };

  const ConAddToList = () => {
    if (CheckNull(addMEP?.value) !== "" && CheckNull(addMEP?.label) !== "") {
      setaddtoListMEP((currentList) => {
        const alreadyAdded = currentList.some(
          (contractor) => String(contractor?.value) === String(addMEP.value)
        );

        return alreadyAdded ? currentList : [...currentList, addMEP];
      });
      setaddMEP(null);
    }
  }

  useEffect(() => {
    let subcontemp = [];
    addtoListMEP?.map((element, index) => {
      subcontemp.push({
        customerID: element.value,
        subContractorName: element.label
      })
    })

    setFormValues({ ...formValues, subContractors: subcontemp })
  }, [addtoListMEP])


  useEffect(() => {
    setFormValues({ ...formValues, startDate: prjStartDate })

    // re-run the validation check on the changed field value
    const errors = validation({
      ...formValues,
      startDate: prjStartDate
    });
    // update the formErrors state
    setFormError({
      ...formErrors,
      startDate: errors["startDate"]
    });
  }, [prjStartDate])

  useEffect(() => {
    setFormValues({ ...formValues, endDate: prjEndDate })

    // re-run the validation check on the changed field value
    const errors = validation({
      ...formValues,
      endDate: prjEndDate
    });
    // update the formErrors state
    setFormError({
      ...formErrors,
      endDate: errors["endDate"]
    });
  }, [prjEndDate])

  const ConDeleteToList = (value) => {
    const MEPcusttype = addtoListMEP?.filter(item => item.value !== value)
    setaddtoListMEP(MEPcusttype);
  }

  const HandleContactChange = (e) => {
    setContactTemp({
      ...contacttemp,
      [e.target.name]: e.target.value,
    });

    // re-run the validation check on the changed field value
    const errors = validationContact({
      ...contacttemp,
      [e.target.name]: e.target.value
    });
    // update the formErrors state
    setContactError({
      ...contactError,
      [e.target.name]: errors[e.target.name]
    });
  };

  const HandleConDepChange = (selectedOption) => {
    setConDepartment(selectedOption)
    setContactTemp({
      ...contacttemp,
      departmentId: selectedOption?.value,
    });

    // re-run the validation check on the changed field value
    const errors = validationContact({
      ...contacttemp,
      departmentId: selectedOption?.value
    });
    // update the formErrors state
    setContactError({
      ...contactError,
      department: errors["department"]
    });
  };

  const HandleConDesChange = (selectedOption) => {
    setConDesignation(selectedOption)
    setContactTemp({
      ...contacttemp,
      designationId: selectedOption?.value,
      designation: selectedOption?.label
    });

    // re-run the validation check on the changed field value
    const errors = validationContact({
      ...contacttemp,
      designationId: selectedOption?.value
    });
    // update the formErrors state
    setContactError({
      ...contactError,
      designation: errors["designation"]
    });
  };

  const HandleContactSubmit = (event) => {
    setContactError(validationContact(contacttemp, contact));
    setContactSubmit(true)
  };

  const HandleFormSubmit = (event) => {
    event.preventDefault();
    setFormError(validation(formValues, customerdata, projectdata));
    setIsSubmit(true);
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      setDisabledSubmit(true);
      if (CheckNull(formValues?.id) !== "") {
        UpdateEntry("project", formValues, setPrjcreateMsg, SuccessMessages?.UPDATED("Project"), ErrorMessages.UPDATE_ERROR("Project"))
      } else {
        CreateEntry("project", formValues, setPrjcreateMsg, SuccessMessages?.CREATED("Project"), ErrorMessages.CREATE_ERROR("Project"))
      }
      setFormError({});
    }
    setIsSubmit(false);
  }, [formErrors]);

  useEffect(() => {
    if (Object.keys(contactError).length === 0 && contactSubmit) {
      if (contacttemp.id > 0) {
        setContact(contact?.map((element, index) => {
          if (element?.id === contacttemp?.id) {
            element.id = contacttemp.id;
            element.name = contacttemp.name;
            element.phone = contacttemp.phone;
            element.email = contacttemp.email;
            element.designationId = contacttemp.designationId;
            element.departmentId = contacttemp.departmentId;
            element.designation = contacttemp.designation;
          }
          return element;
        }
        ));
      }
      else {
        let contactUpdId = { ...contacttemp, id: (contact?.length === undefined ? 0 : contact?.length * 1) + 1 }
        if (contact?.length > 0)
          setContact([...contact, contactUpdId]);
        else
          setContact([contactUpdId]);
      }
      setContactShow(false);
      setContactTemp({})
      setContactSubmit(false);
    }
  }, [contactError])

  useEffect(() => {
    const contactlist = contact?.map((element, index) => {
      let contactdata = {
        name: element.name,
        phone: element.phone,
        email: element.email,
        designationId: element.designationId,
        departmentId: element.departmentId
      }
      return contactdata;
    }
    );
    setFormValues({ ...formValues, projectContacts: contactlist })
  }, [contact])

  const deleteContact = (delContact) => {
    const list = [...contact];
    const temp_index = list.findIndex(x => x.id === delContact.id);
    list.splice(temp_index, 1);
    setContact(list);
  }

  const EditContact = (editContactItem) => {
    setContactTemp(editContactItem)
    setContactShow(true);
  }

  const ContactModalClose = () => {
    setContactSubmit(false);
    setContactTemp({})
    setConDepartment(null);
    setConDesignation(null);
    setContactError({})
    setContactShow(false);
  }

  const ClearFormValues = () => {
    setFormValues({});
    setprjCountry(null);
    setprjSegment(null);
    setprjStatus(null);
    setprjmepCust(null);
    setprjMainCust(null);
    setprjDesignCust(null);
    setprjSuperCust(null);
    setprjClientCust(null);
    setprjDistCust(null);
    setContact([]);
    setaddtoListMEP([]);
    navigate("/project-master")
  }

  useEffect(() => {
    setDisabledSubmit(false);
    if (CheckNull(prjcreateMsg?.message).includes("Failed")) {
      setErrorShow(
        {
          show: true,
          errorMessage: prjcreateMsg.successData
        })
    }
    else if (CheckNull(prjcreateMsg?.message) !== "") {
      setShow(true)
      setFormValues({})
    }
  }, [prjcreateMsg])

  const SuccessDoneClick = () => {
    setShow(false);
    navigate("/project-master")
  }

  const ErrorDoneClick = () => {
    setErrorShow(
      {
        show: false,
        errorMessage: ""
      })
    setPrjcreateMsg(null);
  }

  // Auto-select the default company distributor on a new project
  const defaultDistributorApplied = useRef(false);
  useEffect(() => {
    if (defaultDistributorApplied.current) return;
    if (location?.state?.id || editProject?.id || formValues?.id) return;
    if (!distributordata?.length || !countrydata?.length) return;

    const userProf = getStorageData();
    const defaultDistributor = distributordata.find(
      (item) => item?.defaultCompanyDistributor === true
    );
    if (!defaultDistributor) return;

    // Distributor user can only use their own company
    if (userProf?.userType === 2 && defaultDistributor?.id !== userProf?.userCompanyId) return;

    defaultDistributorApplied.current = true;

    setprjDistCust({
      ...defaultDistributor,
      label: defaultDistributor?.distributorName,
      value: defaultDistributor?.id,
    });

    const countryObj = countrydata.find(
      (item) => item?.id == defaultDistributor?.countryId
    );
    if (countryObj) {
      setprjCountry({
        ...countryObj,
        label: countryObj?.name,
        value: countryObj?.id,
      });
    }

    setFormValues((prevValues) => ({
      ...prevValues,
      distributorId: defaultDistributor?.id,
      countryId: defaultDistributor?.countryId,
    }));
  }, [distributordata, countrydata]);

  return {
    contractorShow,
    ContractorOpen,
    MEPlistData,
    ConAddToList,
    HandleMEPChange,
    addtoListMEP,
    addMEP,
    ConDeleteToList,
    contactShow,
    HandleContactChange,
    contacttemp,
    setContactTemp,
    HandleConDepChange,
    condepartment,
    HandleConDesChange,
    condesignation,
    HandleContactSubmit,
    setConDesignation,
    setConDepartment,
    contactError,
    deleteContact,
    setContactShow,
    EditContact,
    contact,
    formValues,
    HandleFormChange,
    HandleDropDownChange,
    prjSegment,
    prjStatus,
    prjmepCust,
    prjmainCust,
    prjDesignCust,
    prjSuperCust,
    prjClientCust,
    prjDistributorCust,
    prjCountry,
    prjStartDate,
    setprjStartDate,
    prjEndDate,
    setprjEndDate,
    formErrors,
    HandleFormSubmit,
    ClearFormValues,
    show,
    setShow,
    SuccessDoneClick,
    setprjSegment,
    setprjStatus,
    setprjmepCust,
    setprjMainCust,
    setprjDesignCust,
    setprjSuperCust,
    setprjClientCust,
    setprjDistCust,
    setprjCountry,
    prjcreateMsg,
    errorShow,
    ErrorDoneClick,
    ContactModalClose,
    defaultCustomer,
    setaddtoListMEP,
    disabledSubmit,
    customerData,
    disabledCust,
    setContractorShow,
    setListData,
    contractorValue,
    setContractorValue,
    setaddMEP,
    setFormValues,
    setContactError
  };
};

export default useForm;
